{
  "contact-details": {
    "email": "电子邮件地址",
    "mobilePhone": "手机",
    "nextLabel": "$t(common:next): <b>您的全科医生（医生）</b>",
    "otherPhone": "其他电话",
    "text": "我们一直使用这些信息与您联系，但如果需要，您可以更新它们。",
    "title": "您的联系方式"
  },
  "doctor": {
    "gp": "全科医生（医生）姓名",
    "manually": "医生没有显示？<PrimaryText>请手动输入...</PrimaryText>",
    "medicalCentre": "医疗中心",
    "nextLabel": "$t(common:next): <b>您的紧急联系人</b>",
    "searchPlaceholder": "搜索您的全科医生或医疗中心",
    "text": "这是您的全科医生吗？如果不是，请更新。",
    "title": "您的全科医生（医生）"
  },
  "emergency": {
    "fullName": "全名",
    "mobileNumber": "手机号码",
    "nextLabel": "$t(common:next): <b>保险 / 谁来付款</b>",
    "relationship": "与您的关系",
    "select": {
      "child": "子女",
      "friend": "朋友",
      "other": "其他",
      "parent": "父母",
      "spouse": "配偶 / 伴侣"
    },
    "text": "紧急情况下我们应联系谁？",
    "title": "您的紧急联系人"
  },
  "home-address": {
    "building": "建筑或小区的楼层、层级或单元",
    "city": "城镇 / 城市",
    "manually": "地址未显示？<PrimaryText>手动输入...</PrimaryText>",
    "nextLabel": "$t(common:next): <b>您的联系信息</b>",
    "postcode": "邮政编码",
    "searchPlaceholder": "在新西兰搜索地址",
    "street": "街道名称和门牌号",
    "suburb": "郊区或 RD（农村投递）",
    "text": "请输入您的家庭住址：",
    "textSecondary": "这是我们将使用的地址：",
    "title": "您的家庭住址"
  },
  "name-birthdate": {
    "birthDate": "出生日期",
    "dateFormat": "dd/mm/yyyy",
    "familyName": "姓氏：",
    "firstName": "名字",
    "nextLabel": "$t(common:next): <b>您的 NHI 编号和居住状况</b>",
    "preferredName": "偏好姓名",
    "select": {
      "label": "称谓",
      "mr": "Mr",
      "ms": "Ms",
      "mx": "Mx",
      "placeholder": "选择您的称谓"
    },
    "text": "请检查以下信息，并更新任何遗漏或不正确的内容：",
    "title": "您的姓名和出生日期"
  },
  "nhi-residency": {
    "nextLabel": "$t(common:next): <b>您的家庭住址</b>",
    "nhiNumber": "NHI号码（国家健康索引编号）",
    "resident": "您是新西兰居民吗？",
    "residentText": "如果您不是新西兰居民，可能需要为某些服务（例如实验室检测）支付费用。",
    "text": "请检查并更新任何遗漏或不正确的信息：",
    "title": "您的 NHI 号码和居留身份"
  }
}
